export function getGroupedBudgets(budgets, categories, transactions) {
	if (!budgets || !categories) return [];

	return categories.map((group) => {
		const groupId = group._id;

		const groupTotalBudget = budgets.find(
			(b) =>
				b.categoryGroupId === groupId &&
				b.categoryId === "" &&
				b.totalBudget === true,
		);

		const directGroupBudget = budgets.find(
			(b) =>
				b.categoryGroupId === groupId &&
				b.categoryId === "" &&
				b.totalBudget === false,
		);
		const directGroupTransactionsSum = Math.abs(
			parseFloat(
				transactions
					.filter((t) => t.categoryId === groupId && !t.subcategoryId)
					.reduce(
						(sum, t) =>
							sum +
							(t.exchangeRate !== 1
								? t.amount * t.exchangeRate
								: t.amount),
						0,
					)
					.toFixed(2),
			),
		);

		const noSubcategoryItem = {
			budget: directGroupBudget?.amount || 0,
			budgetId: directGroupBudget?._id || "",
			budgetSource: directGroupBudget?.source || "",
			emoji: "❓",
			isBudgetRecurring: directGroupBudget?.recurring || false,
			name: "",
			translationKey: "noSubcategory",
			transactionsSum: directGroupTransactionsSum,
			_id: groupId + "noSub",
		};

		const subcategoriesWithBudget = [
			...group.subcategories.map((subcat) => {
				const subcatBudget = budgets.find(
					(b) => b.categoryId === subcat._id,
				);
				return {
					...subcat,
					budget: subcatBudget?.amount || 0,
					budgetId: subcatBudget?._id || "",
					budgetSource: subcatBudget?.source || "",
					isBudgetRecurring: subcatBudget?.recurring || false,
					transactionsSum: Math.abs(
						parseFloat(
							transactions
								.filter((t) => t.subcategoryId === subcat._id)
								.reduce(
									(sum, t) =>
										sum +
										(t.exchangeRate !== 1
											? t.amount * t.exchangeRate
											: t.amount),
									0,
								)
								.toFixed(2),
						),
					),
				};
			}),
			noSubcategoryItem,
		];

		const totalGroupTransactionsSum = subcategoriesWithBudget.reduce(
			(sum, sc) => sum + sc.transactionsSum,
			0,
		);

		const sumSubBudgets = subcategoriesWithBudget.reduce(
			(sum, sc) => sum + sc.budget,
			0,
		);

		const minimalTotalBudget = sumSubBudgets;

		const isTotalBudgetRecurring =
			groupTotalBudget && groupTotalBudget.amount >= minimalTotalBudget
				? groupTotalBudget.recurring
				: false;
		const hasTotalBudget = Boolean(groupTotalBudget);
		const hardTotalLimit = groupTotalBudget?.amount ?? null;

		const displayedTotalBudget = hasTotalBudget
			? Math.max(hardTotalLimit, minimalTotalBudget)
			: minimalTotalBudget;

		let maximalSubBudget = null;

		if (groupTotalBudget) {
			maximalSubBudget =
				hardTotalLimit > minimalTotalBudget
					? hardTotalLimit - minimalTotalBudget
					: 0;
		}

		return {
			groupId,
			groupName: group.groupName,
			groupTranslationKey: group.groupTranslationKey,
			color: group.color,
			directBudget: directGroupBudget?.amount || 0,
			directBudgetId: directGroupBudget?._id || "",
			directBudgetSource: directGroupBudget?.source || "",
			isDirectBudgetRecurring: directGroupBudget?.recurring || false,
			directGroupTransactionsSum: directGroupTransactionsSum,
			totalBudget: displayedTotalBudget,
			totalBudgetId: groupTotalBudget?._id || "",
			totalBudgetSource: groupTotalBudget?.source || "",
			totalGroupTransactionsSum: totalGroupTransactionsSum,
			minimalTotalBudget,
			maximalSubBudget,
			isTotalBudgetRecurring: isTotalBudgetRecurring,
			subcategories: subcategoriesWithBudget,
		};
	});
}
